'use client'

import { useMemo } from 'react'

import { isNilOrEmpty } from 'shared/utils/ramda'

import { useCheckoutPaymentStore } from '../../payment/store/checkoutPaymentStore'
import { PaymentMethodsNames } from '../../payment/types'

export const useCheckoutPaymentValidation = (cartValidationErrors: string[]) => {
  const paymentMethod = useCheckoutPaymentStore(state => state.paymentMethodId)
  const paymentMethodName = useCheckoutPaymentStore(
    state => state.paymentMethodName
  )
  const rulesAccepted = useCheckoutPaymentStore(state => state.rulesAccepted)
  const blikValid = useCheckoutPaymentStore(state => state.blikValid)

  return useMemo(() => {
    const errors = [...cartValidationErrors]

    if (isNilOrEmpty(paymentMethod))
      errors.push('Nie wybrano metody płatności')
    if (!rulesAccepted) errors.push('Nie zaakceptowano regulaminu')
    if (paymentMethodName === PaymentMethodsNames.Blik && !blikValid)
      errors.push('Wpisz poprawny kod BLIK')

    return errors
  }, [
    cartValidationErrors,
    paymentMethod,
    paymentMethodName,
    rulesAccepted,
    blikValid
  ])
}
